import { AppBar, Typography, Toolbar, Box, Button } from "@mui/material"
import logo from "../res/LOGO_FEALINX.png"

const Navbar = ({ title }) => {
    const disconnect = () => {
        sessionStorage.removeItem("authToken")
        window.location.reload()
    }

    return (
        <AppBar position="static" zIndex="1000" color="transparent" elevation={1}>
            <Toolbar style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box style={{ display: "flex", alignItems: "center" }}>
                    <img src={logo} alt="logo" style={{ width: "120px", height: "40px", marginRight: "16px" }} />
                </Box>
                <Box style={{ flexGrow: 1, textAlign: "center" }}>
                    <Typography variant="h4">{title}</Typography>
                </Box>
                <Box>
                    <Button onClick={disconnect} variant="contained" color="error">Déconnexion</Button>
                </Box>
            </Toolbar>
        </AppBar>
    )
}

export default Navbar